import { useMemo } from 'react';
import { parseErrorToServiceError } from '../helpers';
export function useParseErrorToServiceError(error) {
    return useMemo(function () {
        var _a;
        if (!error)
            return null;
        var exception = (parseErrorToServiceError(error) || {}).exception;
        if (exception === null || exception === void 0 ? void 0 : exception.details) {
            var detail = ((exception === null || exception === void 0 ? void 0 : exception.details) || [])[0];
            return {
                reason: detail === null || detail === void 0 ? void 0 : detail.reason,
                providerMessage: (_a = detail.metadata) === null || _a === void 0 ? void 0 : _a.providerMessage,
            };
        }
        return null;
    }, [error]);
}
